<template>
    <div>
        <!-- 头部 -->
        <v-header @pageSwitch="pageSwitch"></v-header>
        <div class="about-wrap">
        <!-- banner -->
        <img src="http://wx3.sinaimg.cn/large/0067mezugy1fj37u3m2wnj31hc0gowkk.jpg" width="100%" class="banner" ref="top"/>
        <!-- 品牌介绍 -->
        <div class="box" ref="culture">
            <div class="wrapCenter">
                <h2>企业介绍</h2>
                <!-- <p>唐麦创立于2014年。<br>
                开始的想法很简单，希望我们研发的影音产品被大家认可；<br>
                没想到一路走来，得到数百万用户的喜爱和支持；<br>
                唐麦的方向也越来越清晰：定位互联网影音品牌，全心做好影音这件事。</p> -->
                <p>深圳市唐麦科技有限公司成立于2013年，是一家聚焦于影音领域的品牌。以科技、时尚、匠心的三元视角，致力于打造好用的影音产品。产品线涵盖多媒体电脑音箱、家用声卡和音响、耳机等领域。产品以独特的设计，优质音质，满足用户的需求，使得用户快速增加。
唐麦耳机用互联网思维，去掉中间环节，搭建完整的研、产、销全链条，实现科技制造的新模式。目前，已拥有5大研发实验室，品控及供应链2大中心。
                </p>
            </div>
        </div>
        <!-- 发展历程 -->
        <div class="box" ref="culture">
            <div class="wrapCenter">
                <h2>发展历程</h2>
                <p>2014年，唐麦品牌诞生于深圳南山，新品F1问世。</p>
                <p>2015年，唐麦 “声囊耳机”F3面世。</p>
                <p>2016年，唐麦增加了S系列的运动耳机</p>
                <p>2018年，健全了5大研发实验室，品控及供应链2大中心。</p>
                <p>2019年，真无线蓝牙耳机面世，W系列带来全新体验</p>
            </div>
        </div>
        <!-- 品牌使命 -->
        <div class="box" ref="culture">
            <div class="wrapCenter">
                <h2>产品简介</h2>
                <p>深圳市唐麦科技有限公司致力于为用户提供耳塞式、入耳式、运动蓝牙、声卡和音响设备等产品，产品主要以贴近客户需求为主，根据用户提出的建议和需求研究和生产出用户的需求产品，打造实用型产品。</p>
            </div>
        </div>
        <div class="box" ref="culture">
            <div class="wrapCenter">
                <h2>产品类型</h2>
                <p>主要产品有耳塞式、入耳式、运动蓝牙系列、声卡和音响设备</p>
            </div>
        </div>
        <div class="box" ref="culture">
            <div class="wrapCenter">
                <h2>设计理念</h2>
                <p>唐麦品牌致力于年轻人最普适的需求和爱好，不断进行技术和产品创新；原创设计、品质优良，价格友好。</p>
            </div>
        </div>
        <div class="box" ref="culture">
            <div class="wrapCenter">
                <h2>产品优势</h2>
                <p>设计特色：30余款设计专利，独具风格引领市场；</p>
                <p>品质优良：专注声学研发，严守品控把控；</p>
                <p>价格友好：千元定位，百元定价；</p>
            </div>
        </div>
        <div class="box" ref="culture">
            <div class="wrapCenter">
                <h2>核心价值观</h2>
                <p>唐麦一路走来，对客户，对供应商，我们一直坚守着真诚、踏实、专注；</p>
            </div>
        </div>
        <!-- 品牌文化 -->
        <!-- <div class="box" ref="brand">
            <div class="wrapCenter brand">
                <h2>产品类型</h2>
                
                <div class="row">
                    <div class="col-sm-4">
                        <i class="brand-label">真诚</i>
                        <p>坦诚面对伙伴，共同进步；<br/>
                        率真对待客户，把客户当朋友；<br/>
                        真诚是一个团队最美的品德。</p>
                    </div>
                    <div class="col-sm-4">
                        <i class="brand-label">踏实</i>
                        <p>心中不乱，<br/>
                        脚步就不会乱，<br/>
                        踏实稳健才能走得更远。</p>
                    </div>
                    <div class="col-sm-4">
                        <i class="brand-label">专注</i>
                        <p>聚焦影音领域，钻研技术；<br/>
                        坚持初心，注重用户体验。</p>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- 经营理念 -->
        <!-- <div class="box" ref="idea">
            <div class="wrapCenter idea">
                <h2>经营理念</h2>
                <p>虽然身处瞬息万变的大时代，<br>
                但这些原则，我们坚守不变。</p>
                <p>捷径是最远的路——<br>
                相较于幸运和天资，我们更相信踏实和努力。</p>
                <p>少即是多——<br>
                不停做减法，减去纷繁复杂，只留初心本真。</p>
                <p>慢即是快——<br>
                鱼和熊掌不能兼得，执着追求品质，我们愿舍弃效率。</p>
            </div>
        </div> -->
        <!-- 联系我们 -->
        <div class="box last" ref="contact">
            <div class="wrapCenter">
                <h2>联系我们</h2>
                <p>深圳市唐麦科技有限公司<br>
                通讯地址：广东省深圳市南山区西丽街道麻磡南路68号607<br>
                <!-- 公司座机：0755-32986715 <br> -->
                客服电话：400-037-0368 <br>
                电子邮箱：xuwentao@tangmai.com.cn</p>
            </div>
        </div>
        <!-- 公司地图 -->
        <img class="company-map" src="http://wx3.sinaimg.cn/large/0067mezugy1fj3797u7pcj31hc0eyaj4.jpg" width="100%">
        </div>
        <!-- 尾部 -->
        <v-footer @pageSwitch="pageSwitch"></v-footer>
        <!-- 回到顶部 -->
        <goto-top></goto-top>
    </div>
</template>
<script>
    import VHeader from "../components/header"
    import VFooter from "../components/footer"
    // 回到顶部
    import GotoTop from "../components/gotoTop"
    export default{
        components:{
            VHeader,
            VFooter,
            GotoTop
        },
        data(){
            return {
                openjob : 0,
                recruits:[
                    {
                        id: 1,
                        name: "财务经理",
                        sector: "财务部",
                        address: "深圳-南山",
                        duty:["1、负责做好公司会计凭证、会计账簿和其他会计资料的保管和定期归档；",
                        "2、负责公司的资金调配，成本核算，会计核算和分析工作；",
                        "3、负责编制及组织实施财务预算报告，月、季、年度的财务报告；",
                        "4、对公司各项与财务收支有关的经济活动提供财务分析和完善意见；",
                        "5、负责公司的财务管理制度和各项规章制度的编制；",
                        "6、领导交办的其他工作。"],
                        require: ["1、年龄30-40岁，大专及以上学历；",
                        "2、有三年以上财务主管/经理工作经验；",
                        "3、熟悉一般纳税人的工业企业全盘账务，懂外贸；从事过电商会计工作者优先；",
                        "4、熟悉金蝶财务软件；",
                        "5、有初级及以上会计资格证书。"],
                        message:"资本是企业的“粮草”，财务经理是企业“粮草”的重要管理者，我们希望您有高度的责任心和优秀的职业道德，愿为团队的高效运作发挥你全部的光和热。"
                    },{
                        id: 2,
                        name: "客服专员",
                        sector: "客服部",
                        address: "深圳-南山",
                        duty:[
                            "1、通过电商软件与客户沟通，及时解答客户提出的问题，擅于把握客户心态，促进成交；",
                            "2、跟踪发货信息，积极与客户沟通，确保订单和收货地址准确无误；",
                            "3、能积极有效推荐店内活动及产品，保证客户有非常好的购物体验；",
                            "4、及时登记、反馈、统计客户咨询问题，主动追踪处理进度，积极协调解决问题；",
                            "5、及时反馈工作期间发现的问题，并积极提出改进意见和建议；",
                            "6、能积极处理好上级交接的事宜。"
                        ],
                        require:[
                            "1、年龄20-25岁，大专及以上学历，较强的学习能力；",
                            "2、打字速度一分钟60以上为合格！",
                            "3、勤奋踏实、性格活泼开朗，处事随和，工作积极主动；",
                            "4、有良好的团队合作精神，能快速的融入团队；",
                            "5、有电商客服工作经验者优先。"
                        ],
                        message:"淘宝客服并不是“服务员”，而是为公司打江山的线上销售，与线下的销售不同，电商客服无法面对面 与顾客交流，靠的是文字与表情的对话。所以，只要你有足够好的语言感染力和亲和力，并且打字速度在每分钟60字以上，便可以一试。"
                    },{
                        id: 3,
                        name: "文案",
                        sector: "营销部",
                        address: "深圳-南山",
                        duty:[
                            "1、不止是文字控，更是产品控；",
                            "2、走进用户，了解用户，挖掘用户真正的痛点，痒点，G点；用你的文字将它们转化为产品卖点；",
                            "3、有化繁为简，惜字如金的功底，文笔不需要多好，只要恰好；",
                            "4、擅长产品详情文案、新闻稿、包装、产品画册等起稿、撰写、修正；",
                            "5、如果你社交广泛，有大型门户网站或大V自媒体朋友，快到碗里来！"
                        ],
                        require:[
                           "1、年龄22-30岁，大专及以上学历，广告及市场营销专业优先；",
                            "2、1年以上相关工作经验；",
                            "3、投简历请务必附上自鸣得意的作品。"
                        ],
                        message:"谁说文案就两种：X型文案，Y型文案？我们希望你的文案不要被行业规则限制。说人话：“两块钱买不到吃亏，两块钱买不到上当”就很好。"
                    },{
                        id: 4,
                        name: "ID工程师",
                        sector: "设计部",
                        address: "深圳-南山",
                        duty:[
                            "1、根据公司规划，准确理解项目要求以及用户的实际需要，进行产品设计／创新；",
                            "2、主导Audio 类别产品设计，并不断创新设计思路、方法、工具等，优化设计流程；",
                            "3、负责项目的全程设计质量，从概念创意和细化设计，跟模，到最终量产的上市；",
                            "4、进行产品设计研究工作，把握设计方向和设计风格；",
                            "5、制定工作计划，能独立完成和带领team完成产品设计工作；",
                            "6、不断培养优秀设计师，提高团队整体的创新能力。"
                        ],
                        require:[
                            "1、年龄：25-35岁，大专及以上学历，工业设计专业毕业；",
                            "2、3年以上设计经验， 有Audio类别（耳机）产品设计经验；",
                            "3、具备系统设计分析能力、审美偏好变化趋势；深入了解业界前沿的设计理念；",
                            "4、具有良好的沟通能力和协作精神，服务意识，性格开朗，做事积极主动，勤奋踏实；",
                            "5、具有良好的职业道德素质，完美主义者优先；",
                            "6、熟练运用设计软件（Photoshop,Pro－E，Keyshot，Powerpoint，Illustrator ,等）"
                        ],
                        message:"有人说，用户都是盲目的，根本不知道自己要什么；直到优秀的ID设计师将产品带到他们面前：“令人眼前一亮！”，“这就是我想要的！”。于是我们才知道，你是个伟大的魔术师，让所有人满怀期待。"
                    },{
                        id: 5,
                        name: "结构设计师",
                        sector: "设计部",
                        address: "深圳-南山",
                        duty:[
                            "1、负责对耳机等产品的结构设计、改善、新产品开发；",
                            "2、解决耳机开发机生产中的各种结构/工艺等技术问题；",
                            "3、新工艺、新材料的开发；",
                            "4、参与产品的相关评审；",
                            "5、负责产品整体项目的跟进，能统筹相关部门衔接；"
                        ],
                        require:[
                            "1、大专以上学历，至少有5年以上传统耳机、蓝牙无线耳机结构工程设计经验，能独立进行耳机结构设计；",
                            "2、熟练使用CAD、PRO-E等设计软件；",
                            "3、具有良好的沟通能力及团队合作意识及创新精神；",
                            "4、工作责任心强，执行力强；",
                            "5、有C1驾照，驾车熟练；"
                        ],
                        message:"外观再美，也离不开结构的支撑，钢筋水泥的大型建筑如此，小巧精致如耳机亦是如此。我们会为产品赋予美丽的外衣，就等你来给产品一副坚实的骨架了，我们等你。"
                    },{
                        id: 6,
                        name: "视觉设计师",
                        sector: "营销部",
                        address: "深圳-南山",
                        duty:[
                            "1、负责公司品牌的VI 设计、企业形象，公司品牌、系列产品的包装设计与海报输出；",
                            "2、参与创意策略的研讨和制定，平面广告、画册等的创意、VI设计、LOGO设计等",
                            "3、协助市场、招聘相关文案的配套设计工作；",
                            "4、为设计出品提供制作工艺、材质的合理建议，把控出品环节；",
                            "5、部门领导交给的其他各项工作。"
                        ],
                        require:[
                            "1、美术院校毕业优先；",
                            "2、设计领域浸淫数年，拥有卓越的审美品位；",
                            "3、具有超前的创作意念，喜欢探索新鲜、不同、大胆的表现手法；",
                            "4、熟练使用苹果系统、PS、AI、CDR等设计软件；",
                            "5、与团队保持高度沟通、关系融洽；"
                        ],
                        message:"视觉设计，都说第一印象是最重要的，设计师就主导着品牌的第一印象。或许你不是一个喜欢打扮自己的人，但你一定比所有人都懂得何为美。"
                    }
                ]
            }
        },
        methods:{
            pageSwitch(){
                //获取要跳转的当前页面位置的id
                var path = this.$route.path.replace("/about/", "");
                //获取位置的坐标
                var top = this.$refs[path].offsetTop - 100;
                console.log(top);
                //跳转
                $('body, html').animate({
                    scrollTop: top
                }, 800);
            },
            postToggle(event, id){
                if(this.openjob == id){
                    this.openjob = 0;
                }else{
                    this.openjob = id;
                }
                //$(".postlist").parent().find(".post-detail").slideUp();
                $(event.target.closest(".postlist")).parent().find(".post-detail").slideToggle();
                $(event.target.closest(".postlist")).parent().siblings().find(".post-detail").slideUp();
            }
        },
        mounted(){
            $(document).ready(() => {
                this.pageSwitch();
            })
            
        }
    }
</script>
<style scoped>

    .brand-label{
        border-radius: 50%;
        border: 1px #848484 solid;
        width: 160px;
        height: 160px;
        display: block;
        line-height: 160px;
        text-align: center;
        font-style: normal;
        font-size: 24px;
        color: #848484;
        margin-bottom: 20px;
    }

    .brand .row{
        float: left;
        width: 100%;
        margin-top: 80px;
    }

    .idea p{
        margin-bottom: 20px;
    }

    .recruit{
        float: left;
        width: 100%;
        margin-top: 60px;
        border-bottom: 1px #848484 solid;
    }

    .recruit-desc{
        overflow: hidden;
    }
    .recruit-desc b{
        line-height: 30px;
        color: #848484;
    }
    .recruit .row{
        /*margin-top: 6px;*/
        float: left;
        width: 100%;
        margin-left: 0px;
        padding-top: 16px;
        padding-bottom: 10px;
        line-height: 34px;
        border-top: 1px #848484 solid;
    }
    .recruit .btn{
        border: 1px #848484 solid;
        border-radius: 20px;
        background: transparent;
        padding: 6px 20px;
        float: right; 
        margin-top:-6px;
        font-size: 12px;
    }

    .recruit .icon-arrow{
        display: inline-block;
        width: 8px;
        height: 12px;
        background: url(../assets/img/icons/arrow-right.png) no-repeat center;
        background-size: contain;
        vertical-align: middle;
        margin-top: -2px;
        margin-left: 6px;
        transition: 0.5s;
    }

    .recruit .open .icon-arrow{
        transform: rotate(90deg);
    }

    .post-detail {
        width: 100%;
        padding: 30px 15px;
        overflow: hidden;
        display: none;
    }

    .post-detail a {
        padding: 5px 36px;
        background: #ad0000;
        border-radius: 3px;
        color: #FFFFFF;
        letter-spacing: 5px;
        float: left;
        margin-top: 40px;
    }

    @media (max-width: 768px){

        
        
        .brand-label{
            border: none;
            width: auto;
            height: auto;
            line-height: 1rem;
            text-align: left;
            font-size: 0.8rem;
            margin-bottom: 0.6rem;
        }

        .brand .row{
            margin-top: 0rem;
        }

        .brand .row .col-sm-4{
            overflow: hidden;
            margin-top: 1.1rem;
        }

        .recruit{
            margin-top: 1.6rem;
        }

        .recruit-desc b{
            float: left !important;
            line-height: 1rem;
            font-size: 0.6rem;
            font-weight: 500;
        }

        .mohide{
            display: none;
        }

        .recruit .icon-arrow{
            float: right;
            margin-top: 0.1rem;
            margin-right: 0.2rem;
        }

        .about-wrap .box .wrapCenter.join{
            padding: 0;
        }

        /*.join-info{
            padding: 0 0.8rem;
        }*/

        /*.recruit-desc{
            padding: 0 0.8rem;
        }*/

        .recruit .row{
            border-radius: 0;
            background: none;
            border-bottom: 1px #e7e7e7 solid;
            margin-top: 0px;
            padding-top: 0.3rem;
            padding-bottom: 0.2rem;
            
        }

        .recruit .row>div{
            font-size: 0.5rem;
            color: #848484;
            padding-left: 0;
            padding-right: 0;
        }

        .company-map{
            display: none;
        }

        .post-detail{
            padding: 1rem 0;
        }

        .join-info p, .post-detail p{
            line-height: 1rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/about.vue